import { writable } from 'svelte/store';
import { getUid } from './common';
import { DATA_POINT_STATE, MES_KEY_STAGE, MES_STAGE_MAP } from './enum';
const mockCustomers = [
    {
        dbUid: 334,
        uid: 0,
        type: "company",
        name: 'Jotio sro. (DEV)',
        contact: {
            email: 'x@x.cz',
            phone: '000 444 999',
        },
        subElement: [
            {
                ent: {
                    dbUid: 340,
                    uid: 2,
                    type: 'person',
                    name: 'User A (DEV)',
                    contact: {
                        email: 'x@x.cz',
                        phone: '000 444 999',
                    },
                    subElement: [],
                }
            },
            {
                ent: {
                    dbUid: 235,
                    uid: 3,
                    type: 'person',
                    name: 'User B (DEV)',
                    contact: {
                        email: 'x@x.cz',
                        phone: '000 444 999',
                    },
                    subElement: [],
                }
            }
        ]
    },
    {
        dbUid: 334,
        uid: 1,
        type: 'company',
        name: 'cra sro. (DEV)',
        contact: {
            email: 'x@x.cz',
            phone: '000 444 999',
        },
        subElement: []
    }
];
export const DefAppConfig = {
    mesurmentParam: {
        count: 3,
        interval: 5,
        inactiveTimeToWarn: 3,
    },
    graphEtanol: {
        maxPointCount: 6,
    }
};
function genStandartStore(initVal) {
    const { subscribe, set } = writable(initVal);
    return {
        /* subscribe: (subsscription) => {

            subscribe(subsscription)
        }, */
        subscribe: subscribe,
        set: (val) => {
            set(val);
        }
    };
}
function genListStore() {
    const wrList = writable([]);
    const wrMap = writable({});
    let groupMap = {};
    const add = (val, uid) => {
        groupMap[uid] = val;
    };
    const pushNewVal = () => {
        wrList.set(Object.keys(groupMap).map((groupName) => {
            return groupMap[groupName];
        }));
        wrMap.set(groupMap);
    };
    return {
        subscribeList: wrList.subscribe,
        subscribeMap: wrMap.subscribe,
        add: (val, uid) => {
            add(val, uid);
            pushNewVal();
        },
        addAll: (list, uidMap) => {
            //  console.log('FFF', list, uidMap);
            list.forEach((val, i) => add(val, uidMap[i]));
            pushNewVal();
        },
        rm: (val) => {
            delete groupMap[val];
            pushNewVal();
        },
        clear: () => {
            groupMap = {};
            pushNewVal();
        }
    };
}
function genIndexedStore(initVal) {
    const map = {};
    const clearAndSetKey = (key, val) => {
        map[key] = {
            obs: writable(val)
        };
    };
    return {
        subscribe: (index, run) => {
            if (!map[index]) {
                clearAndSetKey(index, initVal);
            }
            return map[index].obs.subscribe(run);
        },
        set: (index, val) => {
            if (!map[index]) {
                clearAndSetKey(index, val);
            }
            else {
                map[index].obs.set(val);
            }
        }
    };
}
export const AppConfgiStore = genStandartStore(DefAppConfig);
// export const ProbeStore = genStandartStore<ProbeFull[]>([]);
export const CustomerStore = genStandartStore([]);
export const MesurmentStore = genListStore();
export const EnvHwStore = genIndexedStore([]);
export const GroupStore = genListStore();
let groupId = 1;
export function getGroupNamePrewiew() {
    return `G:${groupId.toString().padStart(2, '0')}`;
}
export function getGroupName() {
    const newName = getGroupNamePrewiew();
    groupId++;
    return newName;
}
export function genNewGroup(mesurmentList, groupName) {
    const uid = getUid();
    const groupId = (groupName) ? groupName : getGroupName();
    const tempMap = {};
    mesurmentList.forEach(mes => {
        mes.static.targetDataPoints.forEach(dt => {
            const key = `${dt.temp}:${dt.hum}`;
            if (tempMap[key] === undefined) {
                tempMap[key] = {
                    temp: dt.temp,
                    hum: dt.hum,
                    state: dt.state,
                    probeCount: 0,
                    finishCount: 0,
                };
            }
            tempMap[key].probeCount++;
            tempMap[key].state =
                (tempMap[key].state === DATA_POINT_STATE.warn || dt.state === DATA_POINT_STATE.warn) ? DATA_POINT_STATE.warn :
                    (tempMap[key].state === DATA_POINT_STATE.start && dt.state === DATA_POINT_STATE.start) ? DATA_POINT_STATE.start :
                        (tempMap[key].state === DATA_POINT_STATE.fin && dt.state === DATA_POINT_STATE.fin) ? DATA_POINT_STATE.fin :
                            DATA_POINT_STATE.warn;
            tempMap[key].finishCount += (dt.state === DATA_POINT_STATE.fin) ? 1 : 0;
        });
    });
    const ret = {
        dbUid: uid,
        uid: uid,
        displayedId: groupId,
        targetDataPoints: Object.keys(tempMap).map(key => tempMap[key]),
        merurmentList: mesurmentList
    };
    console.log('[INFO - new Group]:', ret.displayedId, ret);
    return ret;
}
let longIdCount = 1;
export function genNewProbe() {
    const probeUid = getUid();
    const idName = longIdCount.toString().padEnd(2, '0').repeat(10);
    longIdCount++;
    const ret = {
        uid: probeUid,
        dbUid: probeUid,
        static: {
            id: idName,
            userId: idName,
            type: 'A',
            typeData: {},
            owner: mockCustomers[0]
        },
        dinamic: {
            associatedMesurmnet: [],
            location: null
        },
        computedVal: {
            displayedId: probeUid.toString().padStart(2, '0'),
        },
    };
    return ret;
}
const probe_1 = genNewProbe();
const probe_2 = genNewProbe();
const probe_3 = genNewProbe();
const probe_all = [probe_1, probe_2, probe_3];
let longIdCoun2 = 0;
export function genNewOrder(probe) {
    const probeUid = getUid();
    const idName = `${String.fromCharCode(65 + longIdCoun2).repeat(3)}-XXXX-${String.fromCharCode(65 + 2 + longIdCoun2).repeat(3)}`;
    longIdCoun2++;
    const ret = {
        uid: probeUid,
        dbUid: 0,
        static: {
            id: idName,
            userId: idName,
            userEvidenceLabel: '',
            orderNote: '',
            baseOwnerCom: {
                dbUid: -1,
                name: '(DEV) 1.1',
            },
            baseOwnerUser: {
                dbUid: -2,
                name: '(DEV) 1.2',
                email: '',
                phone: '',
            },
            baseCustomeCom: {
                dbUid: -3,
                name: '(DEV) 2.1',
            },
            baseCustomeUser: {
                dbUid: -3,
                name: "(DEV) 2.2",
                email: '',
                phone: '',
            },
            probe: {
                dbUid: probe.dbUid,
                id: probe.static.id,
            },
            createdTS: new Date(),
            closedts: null,
            targetDataPoints: [{
                    sequenceId: 0,
                    temp: 10,
                    hum: NaN,
                    state: DATA_POINT_STATE.start
                }, {
                    sequenceId: 1,
                    temp: 0,
                    hum: NaN,
                    state: DATA_POINT_STATE.start
                }, {
                    sequenceId: 2,
                    temp: -10,
                    hum: NaN,
                    state: DATA_POINT_STATE.start
                }],
        },
        dinamic: {
            asociatedProtocols: [],
            exported: false,
            finish: false,
            env: null,
            stage: {
                key: MES_KEY_STAGE['mockStart'],
                val: MES_STAGE_MAP[MES_KEY_STAGE['mockStart']],
                metaList: []
            },
        },
        data: {
            mesurment: [],
        }
    };
    return ret;
}
const mes_1 = genNewOrder(probe_1);
const mes_2 = genNewOrder(probe_2);
const mes_3 = genNewOrder(probe_3);
const mes_all = [mes_1, mes_2, mes_3];
const group_1 = genNewGroup([mes_1]);
const group_2 = genNewGroup(mes_all);
export const DEV_probe = [probe_1, probe_2, probe_3];
export const DEV_mes = [mes_1, mes_2, mes_3];
export const DEV_group = [group_1, group_2];
export const DEV_customers = mockCustomers;
